import { render, staticRenderFns } from "./conflictsWin.vue?vue&type=template&id=4adc104b&"
import script from "./conflictsWin.vue?vue&type=script&lang=js&"
export * from "./conflictsWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports